import i18n from '@/i18n';

export default [
  {
    meta: {
      title: i18n.global.t('onboarding.page_title'),
      requiresAuth: true,
      // Standalone funnel chrome: no sidebar/newsletter/footer noise.
      formScreen: true,
      hideNewsletter: true,
      hideFooter: true,
      favoritable: false,
    },
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('@/pages/onboarding/OnboardingFunnel.vue'),
  },
];
